import { AlertColor } from "@mui/material";

import useServiceStatus from "@app/common/hooks/useServiceStatus";
import Config from "@app/config";

import { EnabledInValue } from "../types/serviceStatusTypes";

const useSiteStatusBanner = (enabledIn: EnabledInValue) => {
  const { serviceStatus, isLoading } = useServiceStatus();
  const configServiceStatus = Config.statusMessage;

  let statusText, severity;

  const configEnabled = configServiceStatus?.enabled?.includes(enabledIn);
  const csServiceStatusEnabled = serviceStatus?.enabledIn?.includes(enabledIn);

  const isEnabled = csServiceStatusEnabled || configEnabled;

  // Prioritize service status from CS endpoint over our config
  if (csServiceStatusEnabled) {
    statusText = serviceStatus?.text;
    severity = serviceStatus?.severity;
  } else if (configEnabled) {
    statusText = configServiceStatus?.text;
    severity = configServiceStatus?.severity as AlertColor;
  }

  return {
    isEnabled,
    statusText,
    severity,
    statusLoading: isLoading,
  };
};

export default useSiteStatusBanner;
